import React, { Component } from 'react';

import { Marker } from 'google-maps-react';

import { CompareBounds } from '../../../helpers/poleHelpers';

import singleSysPoleBlueIcon from '../../../images/poleIcons/blue/01.svg';
import multySysPoleBlueIcon from '../../../images/poleIcons/blue/02.svg';
import singleSysPoleGreenIcon from '../../../images/poleIcons/green/01.svg';
import multySysPoleGreenIcon from '../../../images/poleIcons/green/02.svg';
import singleSysYellowIcon from '../../../images/poleIcons/yellow/01.svg';
import multySysPoleYellowIcon from '../../../images/poleIcons/yellow/02.svg';
import singleSysOrangeIcon from '../../../images/poleIcons/orange/01.svg';
import multySysPoleOrangeIcon from '../../../images/poleIcons/orange/02.svg';
import singleSysRedIcon from '../../../images/poleIcons/red/01.svg';
import multySysPoleRedIcon from '../../../images/poleIcons/red/02.svg';



class Pole extends Component {
    //(ohlList, bounds, zoomLevel, showHealthIndexes, poleSize, onPoleClick) {

    componentDidMount() {
        this.loadPolesList();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.ohlsList.length !== nextProps.ohlsList.length
            || this.props.setMapAsEdited === true
            || CompareBounds(nextProps.zoomLevel, this.props.bounds, nextProps.bounds)
            || this.props.zoomLevel !== nextProps.zoomLevel
            || this.props.showHealthIndexes !== nextProps.showHealthIndexes
            || this.props.poleSize !== nextProps.poleSize
            || this.props.isOhlListEdited !== nextProps.isOhlListEdited) {
            return true;
        }
        else {
            return false;
        }
    }


    componentDidUpdate() {
        this.loadPolesList();
    }


    loadPolesList = () => {

        let resultList = [];

        if (this.props.zoomLevel > 1 && this.props.bounds) {

            ////NOTE: Postaviti filterisanje kada se ubaci ID, da bi se izbegli duplikati
            this.props.ohlsList.forEach(ohl => {
                let polesInRangeList = ohl.stubovi.filter(stub => stub.portal !== true);

                ////NOTE: should be set for 3rd
                polesInRangeList = this.filterPoles(ohl.stubovi, this.props.bounds);

                if (/*zoomLevel > 1 && */polesInRangeList && polesInRangeList.length > 0) {

                    const ohlPoles = polesInRangeList.filter(pole => !pole.portal).map((pole) => {
                        return <Marker
                            options={{ icon: { url: this.returnPoleIcon(pole.sys, pole.healthIndex, this.props.showHealthIndexes), scaledSize: { width: this.props.poleSize, height: this.props.poleSize } } }}
                            key={ohl.name + pole.index}
                            name={pole.name}
                            onClick={() => this.props.onPoleClick(ohl.name, pole.index, pole.lat, pole.lng, pole.sys)}
                            position={{ lat: pole.lat, lng: pole.lng }}
                            title={'OHL: ' + ohl.name + ' Name: ' + pole.name}
                            ohlName={ohl.name}
                            poleName={pole.name}
                            poleItemIndex={pole.index}
                        />
                    })
                    ////NOTE: can use spread instead concat
                    resultList = resultList.concat(ohlPoles);
                }
            });
        }

        this.props.sendChildElementDataToState(this.props.stateElementName, resultList);
    }

    filterPoles = (polesList, bounds) => {
        return polesList.filter(pole =>
            pole.lat >= bounds.latMin
            && pole.lat <= bounds.latMax
            && pole.lng >= bounds.lngMin
            && pole.lng <= bounds.lngMax
        );
    }

    returnPoleIcon = (numberOfSystems, healthIndex, showHealthIndexes) => {

        if (!showHealthIndexes) {
            if (numberOfSystems === 1) return singleSysPoleBlueIcon;
            else return multySysPoleBlueIcon;
        }

        switch (numberOfSystems) {
            case 1: {
                switch (healthIndex) {
                    case 'red': return singleSysRedIcon;
                    case 'orange': return singleSysOrangeIcon;
                    case 'yellow': return singleSysYellowIcon;
                    default: return singleSysPoleGreenIcon;
                }
            }
            default: {
                switch (healthIndex) {
                    case 'red': return multySysPoleRedIcon;
                    case 'orange': return multySysPoleOrangeIcon;
                    case 'yellow': return multySysPoleYellowIcon;
                    default: return multySysPoleGreenIcon;
                }
            }
        }
    }


    render() {
        return null;
    }
}

export default Pole;




